<div ngbDropdown #filterOptionsDrop="ngbDropdown" id="filterOptionsDrop" placement="bottom-right" auto-close="outside">
  <button ngbDropdownToggle class="btn btn-yellow ms-1 dropdown-toggle pe-0 pe-md-3" type="button">
    <app-svg source="icons/feather/filter" height="18"></app-svg>
    <span class="d-none d-md-inline ps-2" i18n="@@FilterButton">Filter</span>
  </button>

  <div ngbDropdownMenu class="filterMenu">
    <form [formGroup]="formService.form" *ngIf="formService.formCreated">
      <div class="filterGroup">
        <label for="filterNumberOfEntriesCheckbox" class="label persistent" i18n="@@FilterNumberOfEntries">
          <input type="checkbox" id="filterNumberOfEntriesCheckbox" class="ms-2 form-check-input"
            formControlName="filterForNumberOfEntries" (change)="updateFilter()">
          Anzahl der Einträge begrenzen
        </label>
        <input type="number" id="filterNumberOfEntriesInput" class="form-control" formControlName="numberOfEntries" />
      </div>
      <div class="filterGroup">
        <label for="filterTimeSpanCheckbox" class="label persistent" i18n="@@FilterTimeSpan">
          <input type="checkbox" id="filterTimeSpanCheckbox" class="ms-2 form-check-input"
            formControlName="filterForTimeSpan" (change)="updateFilter()" />
          Nach Zeitraum filtern
        </label>
        <div *ngIf="!mobileView" ngbDropdown style="width:100%" placement="bottom-right" #myDrop="ngbDropdown">
          <div class="input-group" style="width:100%">
            <input class="form-control" id="filterTimeSpan" formControlName="timeSpan"
              placeholder="Bereich auswählen..." (click)="filterTimeSpanDropdown.click()"
              (change)="onInputChange($event)">
            <div class="input-group-append">
              <button ngbDropdownToggle #filterTimeSpanDropdown id="filterTimeSpanDropdown"
                class="btn btn-outline-secondary" type="button">
                <app-svg source="icons/feather/calendar" height="18"></app-svg>
              </button>
            </div>
          </div>
          <div ngbDropdownMenu style="padding:0" class="date-picker">
            <ngb-datepicker #dp (dateSelect)="onDateSelection($event,myDrop)" [displayMonths]="2" [dayTemplate]="t"
              [footerTemplate]="activeTab == 'own' && datepickerFooter" outsideDays="hidden">
            </ngb-datepicker>
          </div>
        </div>
        <div *ngIf="mobileView" class="input-group" style="width:100%">
          <input type="text" class="form-control" id="filterTimeSpan" formControlName="timeSpan"
            placeholder="DD.MM.YYYY - DD.MM.YYYY">
        </div>
        <div class="mt-3" *ngIf="this.filter.filterSignal">
          <label for="filterSignalWeek" class="label persistent" i18n="@@FilterfilterSignalWeek">
            <input type="checkbox" id="filterSignalWeek" class="ms-2 form-check-input"
              formControlName="filterSignalWeek" (change)="updateFilter()" />
            Mobilfunk-Status ausblenden
          </label>
        </div>
        <div class="mt-2" *ngIf="this.filter.filterDLM">
          <label for="filterDLM" class="label persistent" i18n="@@FilterfilterfilterDLM">
            <input type="checkbox" id="filterDLM" class="ms-2 form-check-input" formControlName="filterDLM"
              (change)="updateFilter()" />
            DLM-Status ausblenden
          </label>
        </div>
      </div>

      <button type="button" class="btn btn-yellow mt-1" id="applyFilters" (click)="applyFilters()">Filter
        anwenden</button>
    </form>
  </div>
</div>

<ng-template #t let-date let-focused="focused">
  <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
    [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="filterOptions.hoveredDate = date"
    (mouseleave)="filterOptions.hoveredDate = null">
    {{ date.day }}
  </span>
</ng-template>